import clsx from "clsx";
import { memo } from "react";
import { useController } from "react-hook-form";

import RawCheckbox from "./RawCheckbox";

interface Props {
  className?: string;
  label?: string;
  name: string;
  required?: boolean;
}

const Checkbox = ({ className, label, name, required }: Props) => {
  const {
    field,
    // fieldState: { error },
  } = useController({
    name,
    rules: { required },
    defaultValue: false,
  });

  const onChange = () => {
    field.onChange(!field.value);
    field.onBlur();
  };

  // const getErrorPrompt = () => {
  //   if (error) {
  //     return (
  //       <span className="text-xs text-red mt-3">
  //         {error.type === 'required' ? '이 항목은 필수입니다' : error.message}
  //       </span>
  //     );
  //   }
  //   return null;
  // };

  return (
    <div className={clsx("flex flex-col", className)}>
      <RawCheckbox
        label={label}
        checked={field.value || false}
        onChange={onChange}
      />
      {/* {getErrorPrompt()} */}
    </div>
  );
};

export default memo(Checkbox);
